import { useQuery } from "@tanstack/react-query";

import { createActivationApi } from "app/pages/activation/services/api";
import type { ShareOfVoiceQueryOptions, ShareOfVoiceWidgetResponse } from "app/pages/activation/types/api";

export const SHARE_OF_VOICE_QUERY_KEY = "homepage-share-of-voice";

export const useShareOfVoiceWidgetQuery = (activationId: string, options?: ShareOfVoiceQueryOptions) =>
    useQuery<ShareOfVoiceWidgetResponse>({
        queryKey: [SHARE_OF_VOICE_QUERY_KEY, activationId],
        enabled: !!activationId,
        queryFn: async () => {
            const api = createActivationApi();

            const result = await api.homeWithData.getShareOfVoice(activationId);

            return result;
        },
        ...options,
        initialData: undefined,
        refetchOnMount: true,
    });
